import { PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { dateFromPhpDateTimeObject, localDateFromPhpDateField } from '@app/pipes/time.pipe';
/**
 * Formats timeline / activity dates (e.g. app-scheduled-activity due time) using regional settings.
 * Parses PHP JSON DateTime `{ date, timezone_type, timezone }`, unix timestamps (s or ms), and ISO strings.
 *
 * Verify from `v4/web/angularES`:
 *   npx ng build --configuration=development
 *   npx ng lint
 */
var TimelineDatePipe = /** @class */ (function () {
    function TimelineDatePipe(settings) {
        this.settings = settings;
    }
    TimelineDatePipe.prototype.transform = function (value, args) {
        var intlSettings = this.settings._csIntlSettings;
        var language = this.settings._csLanguage;
        if (language == 'en') {
            language = 'en-GB';
        }
        var formatString;
        var dateFormat;
        var longDate = parseInt(intlSettings.long_date);
        var defaultDateFormat = language === 'en-GB' ? 'dddd Do MMM YYYY' : 'dddd MMM D YYYY';
        var formats = {
            0: 'ddd Do MMM YYYY',
            1: 'dddd Do MMM YYYY',
            2: 'ddd Do MMMM YYYY',
            3: 'dddd Do MMMM YYYY',
            50: 'ddd MMM D YYYY',
            51: 'dddd MMM D YYYY',
            52: 'ddd MMMM D YYYY',
            53: 'dddd MMMM D YYYY'
        };
        dateFormat = formats[longDate] || defaultDateFormat;
        var timeFormat;
        if (parseInt(intlSettings['time']) === 0) {
            timeFormat = 'h:mm a';
        }
        else if (parseInt(intlSettings['time']) === 1) {
            timeFormat = 'H:mm';
        }
        else {
            timeFormat = 'H:mm';
        }
        if (args == 'datetime') {
            formatString = dateFormat + ' (' + timeFormat + ')';
        }
        else if (args == 'time') {
            formatString = '(' + timeFormat + ')';
        }
        else if (args == 'diarytime') {
            formatString = timeFormat;
        }
        else if (args == 'date') {
            formatString = dateFormat;
        }
        else if (args == 'diarydate') {
            formatString = dateFormat;
        }
        else {
            formatString = dateFormat;
        }
        // ISO instant with Z or numeric offset only (PHP `date` without offset uses local parse below).
        var isoRegexZ = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:?\d{2}|Z)$/;
        if (value && typeof value === 'object' && value.hasOwnProperty('_isAMomentObject')) {
            if (args == 'diarytime' || args == 'diarydate') {
                this.utcTimeString = value;
            }
            else {
                this.utcTimeString = value._d;
            }
        }
        else if (value && typeof value === 'object' && value.hasOwnProperty('date')) {
            var dateStr = value.date;
            if (typeof dateStr !== 'string') {
                this.utcTimeString = new Date(NaN);
            }
            else {
                var fromPhp = dateFromPhpDateTimeObject(value);
                if (fromPhp) {
                    this.utcTimeString = fromPhp;
                }
                else {
                    this.utcTimeString = new Date(dateStr);
                }
            }
        }
        else if (value instanceof Date) {
            this.utcTimeString = value;
        }
        else {
            var strVal = typeof value === 'string' ? value : String(value);
            var phpParsed = localDateFromPhpDateField(strVal);
            if (isoRegexZ.test(strVal)) {
                this.utcTimeString = new Date(strVal);
            }
            else if (phpParsed) {
                // Wall time from API (e.g. scheduled due date); avoid UTC + toLocaleString round-trip
                this.utcTimeString = phpParsed;
            }
            else {
                this.utcTimeString = new Date(strVal + ' UTC');
                this.utcTimeString = new Date(this.utcTimeString.toLocaleString(this.settings._csLanguage, { timeZone: this.settings._csCountryCode.timezone }));
            }
        }
        // Never surface moment's literal "Invalid date" string in the UI.
        var m = moment(this.utcTimeString);
        return m.isValid() ? m.format(formatString) : '';
    };
    return TimelineDatePipe;
}());
export { TimelineDatePipe };
var TimeStringFromSeconds = /** @class */ (function () {
    function TimeStringFromSeconds() {
    }
    TimeStringFromSeconds.prototype.transform = function (value, args) {
        var timeStr = '';
        var timeInSeconds = !isNaN(parseInt(value)) ? parseInt(value) : 0;
        if (timeInSeconds > 0) {
            var secondsToShow = timeInSeconds % 60;
            var minutes = timeInSeconds > 60 ? Math.floor(timeInSeconds / 60) : 0;
            var minutesToShow = minutes > 0 ? minutes % 60 : minutes;
            var hours = minutes > 60 ? Math.floor(minutes / 60) : 0;
            if (hours > 0) {
                var hourText = hours > 1 ? 'hours' : 'hour';
                timeStr += hours + ' ' + hourText;
            }
            if (minutesToShow > 0) {
                var text = minutesToShow > 1 ? 'minutes' : 'minute';
                timeStr += timeStr != '' ? ' ' : '';
                timeStr += minutesToShow + ' ' + text;
            }
            if (secondsToShow > 0) {
                var secText = secondsToShow > 1 ? 'seconds' : 'second';
                timeStr += timeStr != '' ? ' ' : '';
                timeStr += secondsToShow + ' ' + secText;
            }
        }
        return timeStr;
    };
    return TimeStringFromSeconds;
}());
export { TimeStringFromSeconds };
